// extracted by mini-css-extract-plugin
export default {"header":"header_header__Vbvop","title":"header_title__8F2lp","subtitle":"header_subtitle__DL6YY"};